import { Component, inject } from '@angular/core';
import { ToastService, Toast } from '../../app/services/toast.service';
import { CommonModule } from '@angular/common';
import { CustomToastItemComponent } from './custom-toast-item/custom-toast-item.component';

@Component({
  selector: 'app-custom-toast',
  standalone: true,
  imports: [
    CommonModule,
    CustomToastItemComponent
  ],
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss'
})
export class CustomToastComponent {
  private _toastService = inject(ToastService);
  toasts$ = this._toastService.toasts$;
}
